import { render, staticRenderFns } from "./DatabaseSync.vue?vue&type=template&id=35c97eb3&scoped=true&"
import script from "./DatabaseSync.vue?vue&type=script&lang=js&"
export * from "./DatabaseSync.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseSync.vue?vue&type=style&index=0&id=35c97eb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c97eb3",
  null
  
)

export default component.exports